import { publicRequest } from "../../RequestMethods";
import { authFailed, authLoading, authSuccess, emptyUser } from "../slices/AuthSlice";

const clearStoredAuth = () => {
  localStorage.removeItem("persist:root");
  localStorage.removeItem("token");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("user");
  localStorage.removeItem("worker");
  localStorage.removeItem("admin");
};

export const login = async (dispatch, user) => {
  dispatch(authLoading());

  try {
    const res = await publicRequest.post("workers/login", user);

    const data = res.data;

    if (!data?.worker || !data?.token) {
      clearStoredAuth();
      dispatch(authFailed());

      return {
        success: false,
        message: "Réponse serveur invalide",
      };
    }

    dispatch(authSuccess(data));

    return {
      success: true,
      data,
      worker: data.worker,
      token: data.token,
      refreshToken: data.refreshToken,
    };
  } catch (err) {
    clearStoredAuth();
    dispatch(emptyUser());
    dispatch(authFailed());

    return {
      success: false,
      message:
        err?.response?.data?.message ||
        "Identifiants incorrects",
    };
  }
};

export const register = async (dispatch, user) => {
  dispatch(authLoading());
  try {
    const res = await publicRequest.post("workers/register", user);
    dispatch(authSuccess(res.data));
    return { success: true };
  } catch (err) {
    dispatch(authFailed());
    return {
      success: false,
      message: err?.response?.data?.message || "Erreur lors de l'inscription",
    };
  }
};